
import config from '@/config';

export default {
  setup() {
    const { logo } = config;
    return { logo }
  }
}
